export default __webpack_public_path__ + "static/3-bacc9836abe785b70b5d2c02805926db.jpeg";